<div id="about-us">
  <div class="about-shell">
    <section class="about-intro responsive-page-container">
      <div class="intro-panel">
        <div class="intro-copy">
          <app-kx-logo
            size="lg"
            orientation="stacked"
            [light]="true"
          ></app-kx-logo>
          <p class="intro-lead">
            A university-community partnership for research integration,
            translation, and communication.
          </p>
          <div class="intro-actions">
            <youtube-video
              videoID="TR5zH_UIRBo"
              title="Watch our introduction video."
            ></youtube-video>
            <button
              type="button"
              class="audiences-toggle"
              (click)="toggleShowIcons()"
              [attr.aria-expanded]="showIcons"
            >
              Who we serve
              <span class="material-icons" aria-hidden="true">
                {{ showIcons ? "expand_less" : "expand_more" }}
              </span>
            </button>
          </div>
        </div>
        <div
          class="intro-media"
          style="
            background-image: url('https://kx-assets.s3.amazonaws.com/GettyImages-1141509628.png');
          "
          role="img"
          aria-label="People collaborating outdoors"
        ></div>
      </div>
    </section>

    @if (showIcons) {
      <section class="audience-icons responsive-page-container">
        <content-list [content]="iconSlides" type="icon-slider"></content-list>
      </section>
    }

    <section class="about-secondary responsive-page-container">
      <div class="secondary-list">
        <div class="secondary-item expandable" [class.is-open]="expandedPurpose">
          <h2>Our Purpose</h2>
          <p>
            KX brings together researchers, Extension professionals,
            decision-makers, and communicators to share, explore, and engage with
            the world-class research from the College of Food, Agricultural, and
            Environmental Sciences at The Ohio State University.
          </p>
          <button
            type="button"
            class="secondary-link"
            (click)="togglePurpose()"
            [attr.aria-expanded]="expandedPurpose"
          >
            <span class="link-text">{{
              expandedPurpose ? "Show less" : "Read more"
            }}</span>
            <span class="material-icons" aria-hidden="true">
              {{ expandedPurpose ? "expand_less" : "expand_more" }}
            </span>
          </button>
          @if (expandedPurpose) {
            <div class="expanded-content">
              <h3>Collaborations</h3>
              <p>
                KX actively partners with researchers, Extension professionals, and
                other colleges at The Ohio State University. Our goal? To bring
                great minds together and make connections between individual
                research projects. To understand what those connections mean.
              </p>
              <p>
                We’re currently working with several groups to better understand
                health—human, animal, and the environment. How can we boost
                immunity to diseases in humans, animals, and plants? What best
                practices protect our world from future crises? And how are CFAES
                researchers collaborating to answer big questions? Our latest
                collaboration with the Digital Ag Team, the
                <a href="https://eprograms.kx.osu.edu/efields" target="_blank" rel="noopener">eFields Hub</a>, covers data from the last five
                years of on-farm research from Ohio State. Explore eFields reports
                in our searchable database, visualize corn and soybean trial data,
                and learn from eFields partners in the program.
              </p>
              <p>
                We believe knowledge should be accessible to everyone, and we’re
                always looking for new ways to share what we know with our
                communities.
              </p>

              <h3>Projects</h3>
              <p>
                Our integrators stay engaged with researchers, specialists,
                Extension educators, faculty, and staff to explore the important
                work happening in our college and the potential impact of that work
                for the state and region. Integrators focus on the people, their
                research, and the big questions being asked in CFAES. How do we
                solve water quality issues? What can we do to address food
                insecurity? Who should collaborate to improve the health of
                livestock, crops, and communities?
              </p>
              <p>
                In 2021, we focused on the <a href="/food-system-visualization">food system</a>. Then, in 2022, we started exploring the research projects in CFAES focused on improving health in our world. On our site, you'll find a story about how researchers are addressing <a href="/story/hijacking-mosquito-hibernation-diapause-stop-bites">mosquito-born disease</a>, recent Insights around <a href="/story/kx-insights-farmer-health">farmer health</a>, our <a href="/podcast">podcast series</a> highlighting emerging research, <a href="/page/kx-101-local-foods">KX 101</a>s offering the basics around local foods and direct marketing, and a <a href="/landing-page/cearc">360 virtual tour</a> of the new Controlled Environment Agriculture Research Complex.
              </p>
       

              <h3>Themes</h3>
              <p>
                KX is committed to the ideals of knowledge, exploration,
                interdisciplinary communication, and outreach in the context of
                food, agriculture, and environmental sciences. Our work seeks to
                reflect each of these ideals in a unique way. We explore research
                within larger themes of health, water quality, food security, and
                sustainable agriculture.
              </p>
              <p>
                Visit current research around
                <a href="/podcast/12-emerging-lisa-b">poultry disease prevention</a
                >,
                <a href="/landing-page/cearc">controlled environment agriculture</a
                >, and
                <a href="https://eprograms.kx.osu.edu/efields" target="_blank" rel="noopener">eFields precision agriculture data</a>.
              </p>
            </div>
          }
        </div>

        <div class="secondary-item expandable" [class.is-open]="expandedPromise">
          <h2>Our Promise</h2>
          <p>
            KX provides a modern and interactive platform for the university and
            decision-makers to identify needs in our communities, exchange ideas,
            and drive meaningful solutions through research.
          </p>
          <button
            type="button"
            class="secondary-link"
            (click)="togglePromise()"
            [attr.aria-expanded]="expandedPromise"
          >
            <span class="link-text">{{
              expandedPromise ? "Show less" : "Read more"
            }}</span>
            <span class="material-icons" aria-hidden="true">
              {{ expandedPromise ? "expand_less" : "expand_more" }}
            </span>
          </button>
          @if (expandedPromise) {
            <div class="expanded-content">
              <h3>Tools</h3>
              <p>
                Our data tools offer easy access to a world of information. Explore
                our Community Profiles or visit our Knowledge Explorer, compare data
                sets, and create customized reports with information tailored to
                your specifications. We’re building data visualizations to help you
                better understand your world.
              </p>

              <h3>Content</h3>
              <p>
                We strive to communicate science findings in accessible,
                informative, and creative ways. That’s why you’ll see a wide variety
                of information on our site, including interactive tools, videos,
                stories, frequently asked questions, and infographics.
              </p>

              <h3>News</h3>
              <p>
                Work in progress! We hope to create a space to share news about
                upcoming research events, webinars, press releases, and activities.
                Stay tuned.
              </p>

              <h3>Students</h3>
              <p>
                KX encourages both undergraduate and graduate students to engage
                with us. We welcome their perspective to help us reach broader
                audiences. KX works with students in three ways:
              </p>
              <h4>Student Assistants</h4>
              <p>
                We value our student interns and their fresh ideas. Currently, we
                employ three students, but we are always looking for talented
                individuals to help us with science communication. Contact
                <a href="mailto:kx@osu.edu">kx@osu.edu</a> for more information.
              </p>
              <h4>KXpress</h4>
              <p>
                Our scholarship program, KXPRESS, harnesses the creative energy of
                students from The Ohio State University. We invite students to share
                their communication projects or ideas addressing one of our
                college’s grand challenges: water quality, rural-urban interface,
                farm and community stress, food security, and food waste.
              </p>
              <p>
                Students may create a video, gif, dance, game, poster, art, app, a
                meme … whatever they can dream up. Then, we help bring their ideas
                to life. Visit our
                <a href="/topic/student-spotlight">Student Spotlight</a> to see our
                amazing winners!
              </p>
              <h4>Research</h4>
              <p>
                Have a student project that translates your research? We’d love to
                feature your work on our site. Send us an email with the details.
              </p>
            </div>
          }
        </div>

        <div class="secondary-item">
          <h2>Contributors</h2>
          <p>
            Meet the researchers, Extension professionals, and partners who make
            this work possible.
          </p>
          <a routerLink="/directory" class="secondary-link">
            <span class="link-text">View contributors</span>
            <span class="material-icons" aria-hidden="true">east</span>
          </a>
        </div>
      </div>
    </section>

    <section id="contact" class="contact-section responsive-page-container">
      <app-contact-us-form></app-contact-us-form>
    </section>
  </div>
</div>
